import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import MaterialTable from "material-table";
import {
  getMatchingTint,
  getMainBackground,
  getFontColor,
} from "../../ThemeHandlers/theme";

const TableView = (props) => {
  const [headerColor, setHeaderColor] = useState(null);
  const getColor = useSelector((state) => state.auth.color);
  useEffect(() => {
    setHeaderColor(getColor);
  }, [getColor]);

  return (
    <MaterialTable
      columns={props.columns}
      data={props.data}
      actions={props.selection === false ? props.actions : []}
      isLoading={props.load !== undefined ? props.load : false}
      options={{
        headerStyle: {
          backgroundColor: getMainBackground(headerColor),

          color: getFontColor(headerColor),
          fontSize: 14,
          fontWeight: "bold",
        },
        rowStyle: {
          backgroundColor: getMatchingTint(headerColor),
          fontWeight: "normal",
        },
        actionsColumnIndex: -1,
        showTitle: false,
        selection: props.selection,
        toolbar: false,
        filtering: true,
        sorting: false,
        // filterCellStyle: { backgroundColor: "red", border: "1px solid teal" },
      }}
      onSelectionChange={
        props.selection === true ? props.onSelectionChange : null
      }
      onRowClick={props.onRowClick !== undefined ? props.onRowClick : null}
    />
  );
};
export default TableView;
